import {
  setBannerHeight, stickyHeader, animateElements, scrollSection,
} from './helpers';

function animateLogo() {
  const logo = document.querySelector('.logo');
  if (logo) {
    setTimeout(() => {
      logo.classList.remove('logo-animate');
    }, 2000);
  }
}

window.addEventListener('load', () => {
  setBannerHeight();
  stickyHeader();
  animateLogo();

  /* Pop-up menu */
  if (document.querySelector('header .burger-menu')) {
    document.querySelector('header .burger-menu').addEventListener('click', () => {
      document.querySelector('header').classList.toggle('menu-pop-up');

      if (document.querySelector('header').classList.contains('menu-pop-up')) {
        document.body.classList.add('overflow-hidden');
      } else { document.body.classList.remove('overflow-hidden'); }
    });
  }

  setTimeout(() => { animateElements(); }, 1000);


  // Mega Menu


  const navLinks = document.querySelectorAll('.header__nav__left .nav-link');
  if (navLinks) {
    navLinks.forEach((navItem) => {
      navItem.addEventListener('mouseover', function mouseover() {
        navLinks.forEach((el) => {
          el.style.borderColor = 'transparent'; // eslint-disable-line
        });
        this.style.borderColor = '#2dccd2';
        setTimeout(() => {
          document.querySelector('header').classList.add('mega-menu-pop-up');
          document.body.classList.add('overlay');
        }, 200);


        const targetContent = document.querySelector('.mega-menu.visible');
        if (targetContent) {
          targetContent.classList.remove('visible');
        }

        this.parentElement.querySelector('.mega-menu').classList.add('visible');
      });
    });
  }


  document.querySelector('header').addEventListener('mouseleave', () => {
    navLinks.forEach((el) => {
      el.style.borderColor = null; // eslint-disable-line
    });
    setTimeout(() => {
      document.querySelector('header').classList.remove('mega-menu-pop-up');
      document.body.classList.remove('overlay');
    }, 300);
  });
});

window.addEventListener('scroll', () => {
  stickyHeader();
  animateElements();
});

window.addEventListener('resize', () => {
  setBannerHeight();

  if (window.innerWidth > 1024) {
    document.querySelector('header').classList.remove('menu-pop-up');
    document.body.classList.remove('overflow-hidden');
  }
});


// Smooth scroll

const scrollDownArrow = document.querySelector('.scroll-down-arrow');

if (scrollDownArrow) {
  const sectionId = scrollDownArrow.getAttribute('href');
  const elementTop = document.querySelector(sectionId).getBoundingClientRect().top;
  const headerHeight = document.querySelector('header').clientHeight;
  const scrollDistance = (elementTop - headerHeight) + 1;
  scrollDownArrow.addEventListener('click', (event) => {
    event.preventDefault();
    scrollSection(scrollDistance, 500);
  });
}
